import * as React from 'react'
import ExperienceCard from './ExperienceCard'

// Import Experience styling
import './Experience.css'

const Experience: React.FunctionComponent = () => {
  return (
    <>
      <div className="row" id="experience">
        <div className="side-content"></div>
        <div className="main-content">
          <div className="content-header">
            <a className="anchor"></a>
            <h2>Employment History</h2>
            <h4 className="text-center m-4">Here you can find a brief history of the previous positions I&apos;ve worked in.</h4>
          </div>

          <div className="content-body">

            <ExperienceCard location='Tangalooma Island Resort' jobTitle='Gardener' jobInfo='Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.' />

            <ExperienceCard location='P&amp;R Transport' jobTitle='Offsider' jobInfo='Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.' />

            <ExperienceCard location='Packcentre Marketing Services' jobTitle='Storesperson' jobInfo='Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.' />

          </div>
        </div>
        <div className="side-content"></div>
      </div>
    </>
  )
}

export default Experience
